export interface IWalletAccount {
  totalCreditsToday: number;
  totalDebitsToday: number;
  walletBalance: number;
  availableBalance: number;
  totalCredits: number;
  totalDebits: number;
}

export interface IWalletTransaction {
  transactionType: string;
  transactionStatus: string;
  amount: number;
  transactionDate: string;
  transactionName: string;
  providerName: string;
  narration: string;
}

export interface IWalletTransactionHistory {
  transactionDate: string;
  transactions: Array<IWalletTransaction>;
}

export interface IWalletAccountDetails {
  pharmacyName: string;
  pharmacyCode: string;
  accountId: string;
  walletBalance: number;
  availableBalance: number;
  totalCredits: number;
  totalDebits: number;
  bankName: string;
  bankAccountNumber: string;
  bankAccountName: string;

  //for local use
  loadingStatus?: string;
  loadingStatusText?: string;
  // loadingId?: number;
}

export interface IWalletFragmentInterface {
  pharmacyCode: string;
  clientId: number;
}

export const initialWalletDetails: IWalletAccount = {
  totalCredits: 0,
  totalCreditsToday: 0,
  totalDebits: 0,
  totalDebitsToday: 0,
  walletBalance: 0,
  availableBalance: 0,
};
